import React from 'react';

import frFR from 'antd/lib/locale/fr_FR';
import { Moment } from 'moment/moment';

import { InformationMessageViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { DatePicker } from 'components/WrappedComponents';
import { FieldProps } from 'components/WrappedComponents/Form/FormWrapper/type';
import { useApi } from 'hooks/ApiStoreContext';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { InformationMessageFormValues } from 'types/InformationMessage/InformationMessage';
import { CSSUtils } from 'utils/CSSUtils';
import { DATE_FORMAT_WITH_TIME } from 'utils/formats';

import {
  generateRequestDtoFromFormData,
  validateInformationMessageRequest,
} from '../utils';

function DatePickerEnd({
  values,
}: FieldProps<InformationMessageFormValues>): React.ReactElement {
  const controller = useApi().AdminFonctionnelControllerApi;
  const key: keyof InformationMessageFormValues = 'endDate';

  return (
    <DatePicker
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: 'Date de fin',
          rules: [
            {
              required: true,
              validator: async (
                _rule,
                value: Moment | undefined,
              ): Promise<void> => {
                const requestObject = generateRequestDtoFromFormData({
                  ...values,
                  endDate: value || undefined,
                });

                return await validateInformationMessageRequest(
                  controller,
                  requestObject,
                  InformationMessageViolationDtoFormFieldEnum.END_DATE,
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.LlargeWrapperCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      datePickerProps={{
        style: { width: '100%' },
        placeholder: FormPlaceholders.DateWithTime,
        format: DATE_FORMAT_WITH_TIME,
        locale: frFR.DatePicker,
        showTime: true,
      }}
    />
  );
}

export default DatePickerEnd;
